import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/carBind",
  name: "carBind",
  component: function component() {
    return import("../../../views/car-manage/carBind.vue");
  },
  meta: {
    foot: true,
    title: "绑定车牌"
  }
}, {
  path: "/carManage",
  name: "carManage",
  component: function component() {
    return import("../../../views/car-manage/carManage.vue");
  },
  meta: {
    foot: true,
    title: "车辆管理"
  }
}, {
  path: "/carAppeal/:source?",
  name: "carAppeal",
  component: function component() {
    return import("../../../views/car-manage/carAppeal.vue");
  },
  meta: {
    foot: true,
    title: "车辆申诉"
  }
}, {
  path: "/carAppeal_list",
  name: "carAppeal_list",
  component: function component() {
    return import("../../../views/car-manage/carAppeal_list.vue");
  },
  meta: {
    foot: true,
    title: "车辆申诉"
  }
}, {
  path: "/special_vehicles",
  name: "special_vehicles",
  component: function component() {
    return import("../../../views/car-manage/special_vehicles.vue");
  },
  meta: {
    foot: true,
    title: "特种车辆申请"
  }
}, {
  path: "/carAppeal/authentication",
  name: "carAppeal_authentication",
  component: function component() {
    return import("../../../views/car-manage/authentication.vue");
  },
  meta: {
    foot: true,
    title: "客群认证"
  }
}, {
  path: "/carAppeal/special_apply/:group_id?",
  name: "carAppeal_special_apply",
  component: function component() {
    return import("../../../views/car-manage/carAppeal.vue");
  },
  meta: {
    foot: true,
    title: "特种车辆申请"
  }
}, {
  path: "/carAuditing",
  name: "carAuditing",
  component: function component() {
    return import("../../../views/car-manage/carAuditing.vue");
  },
  meta: {
    foot: true,
    title: "车辆审核"
  }
}, {
  path: "/numberplatePay",
  name: "numberplatePay",
  component: function component() {
    return import("../../../views/car-manage/numberplatePay.vue");
  },
  meta: {
    foot: true,
    title: "车牌付"
  }
}];